// AUTO GENERATED FILE - DO NOT EDIT - GENERATED BY cmd/enterprise/*.go generate authz
export default {
	status: 'success',
	data: {
		resources: [
			{
				kind: 'factor-api-key',
				type: 'metaresource',
				allowedVerbs: ['create', 'delete', 'list', 'read', 'update'],
			},
			{
				kind: 'role',
				type: 'role',
				allowedVerbs: [
					'assignee',
					'attach',
					'create',
					'delete',
					'detach',
					'list',
					'read',
					'update',
				],
			},
			{
				kind: 'serviceaccount',
				type: 'serviceaccount',
				allowedVerbs: [
					'attach',
					'create',
					'delete',
					'detach',
					'list',
					'read',
					'update',
				],
			},
		],
		relations: {
			assignee: ['role'],
			attach: ['metaresource', 'role', 'serviceaccount'],
			create: ['metaresource', 'role', 'serviceaccount'],
			delete: ['metaresource', 'role', 'serviceaccount'],
			detach: ['metaresource', 'role', 'serviceaccount'],
			list: ['metaresource', 'role', 'serviceaccount'],
			read: ['metaresource', 'role', 'serviceaccount'],
			update: ['metaresource', 'role', 'serviceaccount'],
		},
	},
} as const;
